import { all, fork, takeLatest, takeEvery } from 'redux-saga/effects';
import { deleteObject, fetchDetail, fetchTable, sendData } from '../helpers/sagaHelpers';

function* watchFetchProfessionsTable() {
  yield takeLatest('professions/fetchTable', fetchTable);
}

function* watchFetchProfessionsDetail() {
  yield takeLatest('professions/fetchDetail', fetchDetail);
}

function* watchSubmitProfessionsDetail() {
  yield takeEvery('professions/submitDetail', sendData);
}

// function* watchDeleteProfessions() {
//   yield takeLatest('professions/deleteProfession', deleteObject);
// }

export default function* rootSaga() {
  yield all([
    fork(watchFetchProfessionsTable),
    fork(watchFetchProfessionsDetail),
    fork(watchSubmitProfessionsDetail)
    // fork(watchDeleteProfessions)
  ]);
}
